import React, { useEffect } from 'react';
import './ErrorNotification.css';

/**
 * Elegant error notification component for Sun Catchers
 * Replaces browser alert() with a refined, warm notification
 */
const ErrorNotification = ({ message, onDismiss, duration = 5000 }) => {
  useEffect(() => {
    // Auto-dismiss after duration
    if (duration > 0) {
      const timer = setTimeout(() => {
        onDismiss();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onDismiss]);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('error-notification-backdrop')) {
      onDismiss();
    }
  };

  return (
    <div className="error-notification-backdrop" onClick={handleBackdropClick}>
      <div className="error-notification">
        <div className="error-notification-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M12 7v6M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <p className="error-notification-message">{message}</p>
        <button
          className="error-notification-close"
          onClick={onDismiss}
          aria-label="Dismiss notification"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M4.5 4.5l9 9M13.5 4.5l-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ErrorNotification;
